import React, { useContext } from 'react';
import { AppContext } from '../../AppContext';
import Alert from './Alert';
import './Alert.css';

const AlertsContainer = () => {
  const { alerts } = useContext(AppContext);

  return (
    <div className="alerts-container container">
      {alerts.length > 0 ? (
        alerts.map(alert => (
          <Alert
            key={alert.id}
            id={alert.id}
            message={alert.message}
            type={alert.type}
          />
        ))
      ) : (
        <Alert
          key="empty"
          id="empty"
          message="⠀⠀"
          type="invisible"
        />
      )}
    </div>
  );
};

export default AlertsContainer;
export {AlertsContainer};